export default "__VITE_PUBLIC_ASSET__e5e21d80__"